<template>
    <form method="post" :action="'/task/'+task.id+'/redo'" :id="'redo_form_task_'+task.id">
        <div style="margin:5px;"
             :class="'panel '+(task.is_overwritten ? 'panel-default task-overwritten hidden' : (task.completed_at ? 'panel-success' : (task.started_at ? 'panel-primary' : 'panel-warning')))">
            <div class="panel-heading"
                 style="padding: 1px; text-align: center;">
                {{task.description.replace('Subtitle', 'Sub').replace('Translated Localization', 'TransLocalization')}}
                <input type="hidden" name="_token" :value="csrfToken"/>
                <span style="float:right; margin-right: 5px; text-shadow: 2px 2px 1px #666"
                      v-if="!!task.completed_at && !task.is_overwritten && task.canRedo">
                   <i class="fa fa-refresh text-white" style="cursor:pointer;" @click="redo();"></i>
                </span>
            </div>
            <div class="panel-body" style="padding: 5px; text-align: left; margin: 0; width: 100%;">
                <div
                        style="width: 100%" align="center">
            <span style="float: left;"
                  class="tool_tip"
                  data-toggle="tooltip"
                  :title="'User: ' + (task.user ? task.user.name + ' (' + task.user.email + ')' : 'System')"
                  v-text="task.user ? task.user.name : 'System'"
            ></span>

                    <span>(id {{task.id}})</span>

                    <span style="float: right;"
                          class="tool_tip"
                          data-toggle="tooltip"
                          :title="task.country.title+' / '+task.language.title"
                          v-text="task.locale">
            </span>
                </div>
                <br/>
                <div style="width:100%" align="center">
            <span style="float: left;"
                  class="tool_tip"
                  data-toggle="tooltip"
                  :title="'Started: ' + (task.started_at ? task.started_at : 'not yet')"
                  v-text="task.started_at ? task.started_at.substring(0, 10) : '-'"></span>
                    <i class="fa fa-long-arrow-right"></i>
                    <span style="float: right;"
                          class="tool_tip"
                          data-toggle="tooltip"
                          :title="'Completed: ' + (task.completed_at ? task.completed_at : 'not yet')"
                          v-text="task.completed_at ? task.completed_at.substring(0, 10) : '-'"></span>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        props: [
            'taskJson',
        ],

        computed: {
            task() {
                return JSON.parse(this.taskJson);
            }
        },

        data() {
            return {
                csrfToken: window.csrfToken,
            };
        },

        methods: {
            redo(form) {
                if (confirm('Are you sure you want to redo this task?')) {
                    _('redo_form_task_' + this.task.id).submit();
                }
            }
        },
    };
</script>
